<template>
  <div>
    <div v-html="marketplaceIcon(mpId)"></div>
    <apexchart :options="chartOptions" :series="series" />
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import { marketplaceIcon } from "@/utils/helper";

export default {
  components: {
    apexchart: VueApexCharts
  },
  props: {
    mpId: {
      type: String
    }
  },
  data() {
    return {
      fields: {
        mp_id: ""
      },
      series: [],
      chartOptions: {
        chart: {
          type: "donut"
        },
        labels: ["Raw", "In Progress", "Need Review", "Reopen", "Closed"],
        colors: ["#E31E52", "#fccd00", "#03AC0E", "#EE4D2D", "#1890FF"],
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: "100%"
              },
              legend: {
                position: "bottom"
              }
            }
          }
        ],
        title: {
          text: "",
          style: {
            fontFamily: "CircularStd",
            fontSize: "20px",
            fontWeight: 500
          }
        },
        noData: {
          text: "Tidak ada data yang tersedia"
        }
      }
    };
  },
  async created() {
    // this.chartOptions.title.text = `Total Per Status ${this.mpId
    //   .charAt(0)
    //   .toUpperCase() + this.mpId.slice(1)}`;
    this.fields.mp_id = this.mpId;
    await this.loadItems();
  },
  methods: {
    async loadItems() {
      await this.$store
        .dispatch("agent/totalStatusPerMP", this.fields)
        .then(response => {
          const { data } = response;
          data.forEach(element => {
            this.series.push(element.total);
          });
          if (this.series.every(item => item < 1)) {
            this.series = [];
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    marketplaceIcon(value) {
      return marketplaceIcon(value);
    }
  }
};
</script>

<style>
.apexcharts-legend-text {
  text-transform: capitalize;
}
</style>



// WEBPACK FOOTER //
// src/views/dashboard/components/totalStatusPerMPAgent.vue